<div class="shorexsignup">
    <div class="shorexsignupbutton row">

        <div class="col-12">
            <!-- Preview (14-day early access): keep personalized Shorex signup link. -->
            <a *ngIf="useExternalSignupLink" (click)="recordExcursionLinkAccess()" class="shorexlink"
                href="{{shorexUrl}}{{ShorexLinkInfo}}"><button class="btn btn-light nav-item nav-link-edit">
                    Shore Excursions & Transfers</button></a>
            <!-- Locked + not in preview: in-portal excursions list only. -->
            <a *ngIf="!useExternalSignupLink" [routerLink]="['/excursions']"
                class="shorexlink">
                <button type="button" class="btn btn-light nav-item nav-link-edit">
                    Shore Excursions & Transfers</button>
            </a>

        </div>

    </div>
</div>
